import gql from 'graphql-tag';
import { useQuery, provideApolloClient } from '@vue/apollo-composable';
import { reactive, watch } from 'vue';
import useDecryptSymbols from './useDecryptSymbols';
import useAlerts from '@/composables/useAlerts';
import apolloClient from './useApolloClient';

const { decryptSymbols } = useDecryptSymbols();
const { addAlert } = useAlerts();

const salespeople = reactive([]);
const outsideSalespeople = reactive([]);
const allActiveUsers = reactive([]);
const allUsers = reactive([]);

const GET_SALESPEOPLE = gql`
  query Users {
    users {
      USERID
      FIRSTNAME
      LASTNAME
      DISPLAYNAME
      EMAIL
      INSIDESALES
      OUTSIDESALES
      ADMIN
      LEADSADMIN
      CONTACTSADMIN
      SHOWLEADS
      SHOWCONTACTS
      SHOWGENERALREPORTS
      SHOWIMPACTREPORT
      DELETED
      OOO
    }
  }
`;

const getUserById = (id) => {
  return allUsers.find((user) => user.USERID?.toUpperCase() === id?.toUpperCase());
};

export default function useUsersQuery() {
  function getUsers() {
    provideApolloClient(apolloClient);

    const { result, error, loading } = useQuery(GET_SALESPEOPLE, {}, { fetchPolicy: 'no-cache' });

    watch(result, () => {
      const decrypted = decryptSymbols(result.value.users);

      const filtersSalespeople = decrypted.filter((salesperson) => salesperson.INSIDESALES == true && !salesperson.DELETED);
      salespeople.splice(0, salespeople.length, ...filtersSalespeople);

      const filtersOutsideSalespeople = decrypted.filter((salesperson) => salesperson.OUTSIDESALES == true && !salesperson.DELETED);
      outsideSalespeople.splice(0, outsideSalespeople.length, ...filtersOutsideSalespeople);

      const filterActiveUsers = decrypted.filter((user) => !user.DELETED);
      allActiveUsers.splice(0, allActiveUsers.length, ...filterActiveUsers);

      allUsers.splice(0, allUsers.length, ...decrypted);
    });

    watch(error, () => {
      if (error.value) {
        console.error('Error fetching users:', error.value);
        addAlert('Error fetching users', 'high', 4);
      }
    });

    return { result, loading };
  }

  return {
    getUsers,
    salespeople,
    outsideSalespeople,
    allActiveUsers,
    allUsers,
    getUserById,
  };
}
